module.exports = __webpack_public_path__ + "static/img/img_login.0b91070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Login/img_login.png
// module id = 1627
// module chunks = 6